import Button from "@mostrans/web-components/components/base/Button";
import React from "react";
import Countdown from "react-countdown";
import { useHistory } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { ROUTE } from "../shared/constants";
import { globalSuccessAtom } from "../shared/globalStates";

export const Success = ({
  title = "Success",
  text = "Success",
  subtext,
  timer = 1000,
  route = "DASHBOARD",
  button = false,
}) => {
  const history = useHistory();
  const setSuccess = useSetRecoilState(globalSuccessAtom);

  const handleComplete = (e) => {
    if (e.completed) {
      setSuccess(false);
      history.replace(ROUTE[route]);
    }
  };

  const handleClick = () => {
    setSuccess(false);
    history.replace("/career/assessment");
  };

  return (
    <div className="body" style={{ textAlign: "center", padding: "40px 0" }}>
      <div
        className="card"
        style={{
          background: "white",
          padding: "60px",
          width: "500px",
          height: "auto",
          borderrdius: "4px",
          boxShadow: "0 2px 3px #C8D0D8",
          display: "inline-block",
          margin: "0 auto",
        }}>
        <div
          style={{
            borderRadius: "200px",
            height: "200px",
            width: "200px",
            background: "#F8FAF5",
            margin: "0 auto",
          }}>
          <i
            className="checkmark text-primary-main"
            style={{
              fontSize: "100px",
              lineHeight: "200px",
              marginLeft: "-15px",
            }}>
            ✓
          </i>
        </div>
        <h1
          className="text-primary-main"
          style={{ fontWeight: "900", fontSize: "40px", marginBottom: "10px" }}>
          {title}
        </h1>
        <p
          className="text-neutral-n6 font-weight-w500"
          style={{ fontSize: "20px", margin: "0" }}>
          {text}
          <br /> {subtext}
          <Countdown
            date={Date.now() + parseInt(timer)}
            renderer={(e) => <span> {e.seconds} &nbsp;second</span>}
            onComplete={(e) => handleComplete(e)}
          />
        </p>
        {button && (
          <Button
            style={{ margin: "10px" }}
            variant="contained"
            color="primary"
            onClick={() => handleClick()}>
            Selesai
          </Button>
        )}
      </div>
    </div>
  );
};

export default Success;
